import { render } from "./EvaluateQuotaActivationRule.vue?vue&type=template&id=5a53e378&scoped=true"
import script from "./EvaluateQuotaActivationRule.vue?vue&type=script&lang=js"
export * from "./EvaluateQuotaActivationRule.vue?vue&type=script&lang=js"

import "./EvaluateQuotaActivationRule.vue?vue&type=style&index=0&id=5a53e378&lang=scss&scoped=true"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a53e378"]])

export default __exports__